// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Thanks__wrapper___2zAYe","logo":"Thanks__logo___1Wdj2","container":"Thanks__container___1pf37","mobile":"Thanks__mobile___1rMTn","subtitle":"Thanks__subtitle___35e10","background":"Thanks__background___xwLNq","link":"Thanks__link___2hyAd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Thanks/Thanks.scss
// module id = mQ9M
// module chunks = 0